<template>
  <div class="container">
    <h1 class="page-title">CORE Loader - Upload SID Document</h1>
    <div class="pt-10">
      <table class="data-table" id="mytable">
        <thead>
          <tr>
            <th>SN</th>
            <th>Unit Category</th>
            <th>Expense Category - Expenditure Type</th>
            <th>Current</th>
            <th>Expectation</th>
            <th>Year</th>
            <th>Justification</th>
            <th>Department</th>
          </tr>
        </thead>
      </table>
    </div>

    <div class="pt-5 pb-10 w-full">
      <button
        class="form-button"
        style="background-color: green"
        v-if="!uploadingContent"
        @click.prevent="storeSid"
      >
        Submit
      </button>
    </div>

    <p v-if="uploadingContent">Uploading <span class="loader"></span></p>

    <label>Upload CSV File</label><br />
    <input
      type="file"
      class="bg-red-800 p-2 w-full mt-8 text-gray-200 hover:bg-red-900 border rounded-md"
      @change="handleFileUpload"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import Swal from "sweetalert2";

const id = ref(0);
const unitCategory = ref("");
const expectation = ref("");
const year = ref("");
const justification = ref("");
const current = ref("");
const expenseExpenditureName = ref("");
const department = ref("");
const form = ref([]);
const csvfile = ref(null);
const uploadingContent = ref(false);
const url = ref("");
const updateMode = ref(false);

const handleFileUpload = async (event) => {
  const file = event.target.files[0];

  if (!file) {
    Swal.fire("Error", "No file selected", "error");
    return;
  }

  if (!file.name.endsWith(".csv")) {
    Swal.fire("Error", "Only CSV files are allowed", "error");
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    Swal.fire("Error", "File size exceeds 5MB limit", "error");
    return;
  }

  if (!url.value) {
    Swal.fire("Error", "API URL is not set", "error");
    return;
  }

  csvfile.value = file;
  const formdata = new FormData();
  formdata.append("template", csvfile.value);

  try {
    const response = await axios.post(
      `${url.value}/api/v1/core/upload-services`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(`Response ${response.data}`);
    console.log(`Response for preview: ${response.data.data}`);

    if (response.status === 200 && Array.isArray(response.data.data)) {
      const processedData = response.data.data.map((element) => ({
        coa_unit_category_alias: element["Unit Category"],
        expense_expenditure_name:
          element["Expense Category - Expenditure Type"],
        current: element["Current"] || 0,
        expectation: element["Expectation"] || 0,
        justification: element["Justification"] || "No justification provided",
        department: element["Department"] || "Unknown",
        year: element["Year"] || new Date().getFullYear(),
      }));

      localStorage.setItem("data", JSON.stringify(processedData));
      form.value = processedData;

      datatable();
      Swal.fire("Success", "File uploaded successfully!", "success");
    } else {
      Swal.fire("Error", "Invalid file format or response", "error");
    }
  } catch (error) {
    console.error("Upload Error:", error.response?.data || error.message);
    Swal.fire("Error", error.message || "Failed to upload file", "error");
  }
};

const datatable = () => {
  if ($.fn.DataTable.isDataTable("#mytable")) {
    $("#mytable").DataTable().destroy();
  }

  $("#mytable").DataTable({
    paging: true,
    searching: true,
    ordering: true,
    data: form.value,
    columns: [
      { data: null, render: (data, type, row, meta) => meta.row + 1 },
      { data: "coa_unit_category_alias" },
      { data: "expense_expenditure_name" },
      { data: "current" },
      { data: "expectation" },
      { data: "year" },
      { data: "justification" },
      { data: "department" },
    ],
  });
  console.log("DataTable Initialized with:", $("#mytable").DataTable().data());
};

const storeSid = async () => {
  uploadingContent.value = true;

  try {
    const { status, data } = await axios.post(
      `${url.value}/api/v1/sid/upload`,
      form.value
    );

    if (status === 200 || status === 201) {
      Swal.fire({
        title: "Success!",
        text: data.message,
        icon: "success",
        confirmButtonText: "Ok!",
      });
      uploadingContent.value = false;
    } else {
      Swal.fire({
        title: "Server Error",
        text: data.message,
        icon: "error",
        confirmButtonText: "Ok!",
      });
    }
  } catch (error) {
    console.error("Error from server:", error);

    // Check if error.response exists
    let errorMsg = "An unexpected error occurred.";
    if (error.response) {
      // Server responded with a status outside the 2xx range
      errorMsg =
        error.response.data?.message ||
        `Request failed with status code ${error.response.status}`;
    } else if (error.request) {
      // Request was made but no response received
      errorMsg = "No response received from the server.";
    } else {
      // Something else happened while setting up the request
      errorMsg = error.message;
    }

    Swal.fire({
      title: "Server Error",
      text: errorMsg,
      icon: "error",
      confirmButtonText: "Ok!",
    });
  }
};

// const storeSid = async () => {
//   if (form.value.length === 0) {
//     Swal.fire("Error", "No data to submit", "error");
//     return;
//   }

//   uploadingContent.value = true;

//   try {
//     // Ensure the payload is correctly formatted
//     const payload = form.value.map((item) => ({
//       unitCategory: item.coa_unit_category_alias || "Unknown",
//       expense_expenditure_name: item.expense_expenditure_name || "N/A",
//       current: item.current || "0",
//       expectation: item.expectation || "0",
//       justification: item.justification || "No justification provided",
//       department: item.department || "Unknown",
//       year: item.year || new Date().getFullYear(),
//     }));

//     console.log("Payload being sent:", payload); // Debugging output

//     const response = await axios.post(`${url.value}/api/v1/sid/upload`, payload, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     if (response.status === 200 || response.status === 201) {
//       Swal.fire("Success!", "Data Stored Successfully!", "success");
//       form.value = []; // Clear form data after successful submission
//     }
//   } catch (error) {
//     console.error("Error saving data:", error);
//     Swal.fire("Error", "Failed to save data", "error");
//   } finally {
//     uploadingContent.value = false;
//   }
// };

window.updateData = (index) => {
  updateMode.value = true;
  const data = form.value[index];
  id.value = index;
  unitCategory.value = data.coa_unit_category_alias;
  expenseExpenditureName.value = data.expense_expenditure_name;
  current.value = data.current;
  expectation.value = data.expectation;
  year.value = data.year;
  justification.value = data.justification;
  department.value = data.department;
};

const settings = ref();
const getUrl = () => {
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);
    url.value = settings.value.defaultStates[0].budget;
  }
};

onMounted(() => {
  getUrl();
});
</script>

<style>
.container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.data-table th,
.data-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}

.form-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.form-fields {
  margin-top: 20px;
}

.input-field {
  width: 40%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #ccc;
}

.loader {
  width: 10px;
  height: 10Zpx;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
